import React from "react";
import PropTypes from "prop-types";
import Chip from "components/Chip";
import CollapsibleDrawerContent from "components/Drawer/components/CollapsibleDrawerContent/CollapsibleDrawerContent";
import DrawerContent from "components/Drawer/components/DrawerContent/DrawerContent";
import EmptyContent from "components/EmptyContent";
import {EntityList} from "components/EntityList";
import {ENTITY_TYPE} from "utils/entities";
import {capitalize} from "utils/formatters";

const EntitySection = ({
  collapsible = true,
  count = 0,
  data = [],
  entityType,
  entityListProps = null,
  ...rest
}) => {
  const hasEntityData = data?.length;
  const titleIcon = <Chip>{count}</Chip>;

  const content = hasEntityData ? (
    <EntityList
      data={data}
      entityType={entityType}
      withDrawer
      {...entityListProps}
    />
  ) : (
    <EmptyContent name={entityType} />
  );

  // @todo When `EntityList` component is complete, remove this conditional
  // and just render it that inside the `EntityDrawer` instead.
  if (!collapsible) {
    return <DrawerContent {...rest}>{content}</DrawerContent>;
  }

  return (
    <CollapsibleDrawerContent
      defaultCollapsed={!hasEntityData}
      title={capitalize(entityType)}
      titleIcon={titleIcon}
      {...rest}>
      {content}
    </CollapsibleDrawerContent>
  );
};

EntitySection.propTypes = {
  /**
   * Determines if the collapsible version of the component will render.
   */
  collapsible: PropTypes.bool,

  /**
   * A number representing the total count of entity objects.
   */
  count: PropTypes.number,

  /**
   * An array of entity data displayed within the (opened) drawer.
   */
  data: PropTypes.array,

  /**
   * The entityType of entity the component should handle.
   */
  entityType: PropTypes.oneOf([
    ENTITY_TYPE.assets,
    ENTITY_TYPE.indicators,
    ENTITY_TYPE.observables,
    ENTITY_TYPE.relations
  ]),
  /**
   * EntityList component props passed straight through to list
   * component to customized the view type.
   */
  entityListProps: PropTypes.shape({
    ...EntityList.propTypes
  })
};

export default EntitySection;
